/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { useLocation } from "react-router";
/* import SVG from "react-inlinesvg"; */
import { /* toAbsoluteUrl, */ checkIsActive } from "../../../../_helpers";
import Joyride, { STATUS } from 'react-joyride';
import { useHistory } from "react-router-dom"
import { Button } from "react-bootstrap"
export function HeaderMenu({ layoutProps }) {
    const location = useLocation();
    const history = useHistory()
    const [run, setRun] = useState(false)
    const [complete, setComplete] = useState(false)

    const getMenuItemActive = (url) => {
        return checkIsActive(location, url);
    }
    const tutorials = {
        "/dashboard": [
            {
                target: 'body',
                content: 'Welcome to GTO Marketing!',
                placement: 'center',
                title: "Welcome",
            },
            {
                target: '.products-menu-ref',
                content: 'Here you can manage products :)',
                placement: 'right',
            },
            {
                target: 'body',
                content: 'All clients products are here, you can add, edit and also delete it',
                placement: 'center',
                path: "/products",
            },
            {
                target: '.campaigns-menu-ref',
                content: 'Here you can manage the campaigns :)',
                placement: 'right',
            },
            {
                target: 'body',
                content: 'All campaigns are here',
                placement: 'center',
                path: "/campaign",
            },
            {
                target: '.employees-menu-ref',
                content: 'Here you can manage employees :)',
                placement: 'right',
            },
            {
                target: 'body',
                content: 'All employees are here, you can add, edit and also delete it',
                placement: 'center',
                path: "/employees",
            },
        ],
        "/products": [
            {
                target: 'body',
                content: 'All clients products are here, you can add, edit and also delete it',
                placement: 'center',
                duplicated: true
            },
            {
                target: '.new-product-ref',
                content: 'Here you can add new products :)',
                disableScrolling: true,
            }
        ],
        "/campaign": [
            {
                target: 'body',
                content: 'All campaigns are here',
                placement: 'center',
                duplicated: true
            },
            {
                target: '.new-campaign-ref',
                content: 'Here you can preview your campaigns :)',
                disableScrolling: true,
                placement: 'left',
            }
            
        ],
        "/employees": [
            {
                target: 'body',
                content: 'All employees are here, you can add, edit and also delete it',
                placement: 'center',
                duplicated: true
            },
            {
                target: '.new-employees-ref',
                content: 'Here you can add new employees :)',
                placement: 'bottom',
            }
        ],

    }
    const sections = Object.values(tutorials)
    const [all_tutorials] = sections.map((menu) => {
        const adds = []
        for (const section of menu) {
            adds.push(section)
            if (section.path) {
                const subsection = tutorials[section.path]
                for (const section of subsection) {
                    if(section.duplicated){
                        continue
                    }
                    adds.push(section)

                }
            }
        }
        return adds
    })
    const getHelpers = (helpers) => {
        console.log(helpers)
        // this.helpers = helpers;
    };
    const handleJoyrideCallback = (data) => {
        const { status } = data;
        const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];

        if (finishedStatuses.includes(status)) {
            setRun(false);
        }
        if (data.step?.path) {
            history.push({
                pathname: data.step.path
            })
        }
    };
    return <div
        id="kt_header_menu"
        className={`header-menu header-menu-mobile ${layoutProps.ktMenuClasses}`}
        {...layoutProps.headerMenuAttributes}
    >
        <Joyride
            callback={handleJoyrideCallback}
            getHelpers={getHelpers}
            run={run}
            styles={{
                options: {
                    primaryColor: '#3c245c',

                }
            }}
            scrollToFirstStep={true}
            showProgress={true}
            showSkipButton={true}
            continuous={true}
            hideCloseButton={true}
            disableCloseOnEsc={true}
            disableOverlayClose={true}
            disableBeacon={true}
            steps={complete ? all_tutorials : (tutorials[location.pathname] ?? [])}

        />
        <ul className={`menu-nav ${layoutProps.ulClasses}`}>
            {/* <li className={`menu-item menu-item-rel ${getMenuItemActive('/dashboard')}`}>
                <NavLink className="menu-link" to="/dashboard">
                    <span className="menu-text">Dashboard</span>
                    {layoutProps.rootArrowEnabled && (<i className="menu-arrow" />)}
                </NavLink>
            </li> */}
            <li className={`menu-item menu-item-rel`}>

                <Button
                    variant="light"
                    className="menu-link"
                    disabled={!tutorials[location.pathname]}
                    onClick={() => {
                        if (getMenuItemActive("/dashboard")) {
                            setComplete(true)
                        } else {
                            setComplete(false)

                        }
                        setRun(true)
                    }}>
                    <span className="menu-text">Run Tutorial</span>
                    <i className="menu-arrow" />
                </Button>
            </li>
         

        </ul>
    </div>;
}